<template>
  <div>
    <!-- light-row
    @row-select="x=>$emit('change',x)"-->
    <list
      row-key="PurchaseArrivalId"
      ref="list"
      unit="加工费对账单"
      :page="page"
      :queryParamsAppend="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.getListChkPay"
      urlHash="finance/dealings/machiningbill"
      @selectClick="selectClick"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="外协单位" label-width="100px">
          <!-- <el-input clearable v-model="params.DocNo" placeholder="请输入工单号" /> -->
          <select-input
            placeholder="请选择外协单位"
            :label="params.TradeUnitName"
            v-model="params.TradeUnitId"
            @click="openTradeunit"
          />
        </el-form-item>
        <el-form-item label="单据编号" label-width="100px">
          <el-input
            clearable
            v-model="params.DocNo"
            placeholder="请输入单据编号"
          />
        </el-form-item>
        <el-form-item label="对账周期" label-width="100px">
          <el-select v-model="params.Cycle" @change="cycleChange">
            <el-option value="今天"></el-option>
            <el-option value="昨天"></el-option>
            <el-option value="近3天"></el-option>
            <el-option value="近7天"></el-option>
            <el-option value="近14天"></el-option>
            <el-option value="本周"></el-option>
            <el-option value="上周"></el-option>
            <el-option value="本月"></el-option>
            <el-option value="上月"></el-option>
            <el-option value="本季"></el-option>
            <el-option value="上季"></el-option>
            <el-option value="本年"></el-option>
            <el-option value="上年"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对账日期"  label-width="100px">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="
              (x) => {
                params.DocDateStart = x.Start;
                params.DocDateEnd = x.End;
              }
            "
            style="min-width:180px"
          />
        </el-form-item>
        <!-- <el-form-item label="对账日期" v-if="isMB" label-width="100px">
          <el-date-picker
            v-model.trim="params.DocDateStart"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="截止日期" v-if="isMB" label-width="100px">
          <el-date-picker
            v-model.trim="params.DocDateEnd"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择结束时间"
          ></el-date-picker>
        </el-form-item> -->
      </template>
      <template slot="table">
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <tradeunit-dialog
      ref="tradeunitDialog"
      in-dialog
      selectable
      @select="setTradeunit"
    />
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/finance/dealings/machiningbill/list.json";
import tableParam from "@/data/finance/dealings/machiningbill/query.json";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";

export default {
  mixins: [listMixin],
  components: {
    list,
    tradeunitDialog,
  },
  data() {
    return {
      api: require("@/api/rp/pay").default,

      params: {
        DocNo: "",
        Cycle: "",
        BusinessTypes: null,
        TradeUnitId: null,
        TradeUnitName: "",
        TradeUnitTypes: [3],
        DocDocDateStart: null,
        DocDateEnd: null,
        SourceTypeIds:[35,0]
      },
      isMB: this.$store.state.isMB,
    };
  },

  mounted() {
    if (!this.$permission.canPrice("/finance/dealings/machiningbill")) {
      const findIndex = this.$refs.list.tableList.findIndex(item => item.tableName == "NeedAmount");
      if (findIndex >= 0) this.$refs.list.tableList.splice(findIndex, 1);
      const findIndex1 = this.$refs.list.tableList.findIndex(item => item.tableName == "AlreadyAmount");
      if (findIndex1 >= 0) this.$refs.list.tableList.splice(findIndex1, 1);
      const findIndex2 = this.$refs.list.tableList.findIndex(item => item.tableName == "LeftAmount");
      if (findIndex2 >= 0) this.$refs.list.tableList.splice(findIndex2, 1);
    }
  },
  methods: {
    onExport() {
      var list = this.$refs.list;
      var listParams = list.tempQueryParams;
      var fields = list.tableList.map(x => x.tableName);
      var params = { ...listParams, Fields: fields.join(',') };
      // console.log('onExport', params);
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.getProcessListChkPayExport(params).then(res => {
        loading.close();
      })
    },
    toURL(o){
      this.$router.push(o)
    },
    selectClick(row){
      console.log('row', row)
      
      if(row.SrcVouTypeName === '加工费用单'){
        let data = {
          OutPocCostId: row.SourceId,
        }
        this.$router.push({
        name: "editMachiningCost",
          params: { mode: "edit", data },
        });
      }

      if(row.SrcVouTypeName === '付款单'){
        let id = row.SourceId;
       this.api.info(id).then(res => {
        if(res.Code === 0){
          this.toURL({
            name: 'editpayment',
            params: {
              type: 'edit',
              data: res.Data
            }
          })
        }else{
          this.$message({type: 'warning', message: res.Msg})
        }
       })
      }
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData({TradeUnitType:3});
      });
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.FullName;
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.DocDateStart = start;
      this.params.DocDateEnd = end;
      this.query();
    },
  },
};
</script>
